import { Component, OnInit, Inject, ElementRef, Renderer2 } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ShopSettingsService } from '../../modules/general/services/shop-settings.service';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-pin-popup',
  templateUrl: './pin-popup.component.html',
  styleUrls: ['./pin-popup.component.css']
})
export class PinPopupComponent implements OnInit {

  readonly pinMaxLength = 10;

  pin: string = '';
  pinValid: boolean;
  showInvalidPinMessage: boolean;
  validatePin = (pin: string): Observable<boolean> => of(false);
  result: any;

  constructor(
    public dialogRef: MatDialogRef<PinPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private ref: ElementRef,
    public shopSettingsService: ShopSettingsService,
    private renderer: Renderer2,
  ) {
    // this.pin = data.pin;
    this.showInvalidPinMessage = false;
    this.validatePin = data.validatePinMethod;
  }

  ngOnInit(): void {
    if (this.shopSettingsService.isVUMode) {
      this.renderer.addClass(this.ref.nativeElement, 'vu-mode');
    }
  }

  closeClick(): void {
    this.dialogRef.close();
  }

  confirmClick(): void {
    this.validatePin(this.pin).subscribe(
      result => {
        this.result = result;
        if (result) {
          this.pinValid = true;
          this.closeClick();
        } else {
          this.showInvalidPinMessage = true;
        }
      }
    )
  }

  get hiddenPin(): string {
    if (!this.pin) {
      return ' ';
    }
    return this.pin.split('').map(() => '*').join('');
  }

  onKeyClick(key: string): void {
    this.appendPinKey(key);
  }

  onKeyDeleteClick(): void {
    this.removeLastCharFromPin();
  }

  appendPinKey(key: string): void {
    if (this.pin == null) {
      this.pin = '';
    }

    if (this.pin.length >= this.pinMaxLength) {
      return;
    }

    this.pin += key;
    this.showInvalidPinMessage = false;
  }

  removeLastCharFromPin(): void {
    if (this.pin == null) {
      return;
    }
    this.pin = this.pin.slice(0, -1);
    this.showInvalidPinMessage = false;
  }
}
